function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useState, useEffect, useRef } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import '../styles/abstract.scss';
import { useTranslate, T } from 'shared/helper/translate';
import Files, { endpoints } from 'shared/helper/file';
import { FILE_STATUS } from 'shared/helper/file/constants';
import { Controls, useFormHelpers } from 'shared/helper/form';
import convertFormDataToAbstractCreateRequest from 'shared/view/abstract-conversion-service';
import FileRubriq from 'shared/helper/file/components/FileRubriq';
import { createAbstract, deleteAbstractFile } from 'researcher/abstract/actions';
import { trackAbstractUploadModalOpened, trackAbstractFileSelected, trackAbstractFileRemoved, trackAbstractUploadError, trackAbstractDisclaimerAcknowledged, trackAbstractGenerationStarted, trackAbstractGenerationCompleted, trackAbstractSubmissionCancelled } from 'researcher/helpers/abstractMixpanelEvents';
import useAbstractTrackingProps from 'researcher/helpers/useAbstractTrackingProps';
import { syncUser } from '../actions';
import RubriqUploadButton from './RubriqUploadButton';
import DualRangeSlider from './DualRangeSlider';
import useAbstractSettings, { ABSTRACT_TYPE_UNSTRUCTURED, ABSTRACT_TYPE_STRUCTURED, WORD_COUNT_MIN, WORD_COUNT_MAX, WORD_COUNT_STEP, abstractSettingsDefaultValues } from './useAbstractSettings';
var fileType = 'digitalAbstract';
var Form = Controls.Form;

// Map screen index to the step name used in Submission Cancelled
var SCREEN_STEP_NAMES = ['upload', 'settings'];

// Temporarily hidden - flip back to true to re-enable. Defaults to false in
// abstractSettingsDefaultValues, so hiding this leaves it permanently unrequested.
var SHOW_GRAPHICAL_ABSTRACT_OPTION = false;
var defaultValues = _objectSpread({
  digitalEditFiles: [],
  manuscriptComplete: false
}, abstractSettingsDefaultValues);
var SubmitAbstractModal = function SubmitAbstractModal(_ref) {
  var _digitalEditFiles$fin, _digitalEditFiles$fin2, _digitalEditFiles$som, _digitalEditFiles$som2, _digitalEditFiles$som3;
  var open = _ref.open,
    onClose = _ref.onClose,
    _ref$entryPoint = _ref.entryPoint,
    entryPoint = _ref$entryPoint === void 0 ? 'new_abstract_button' : _ref$entryPoint;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var trackingProps = useAbstractTrackingProps();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPageIndex = _useState6[0],
    setCurrentPageIndex = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var uploadTrackedRef = useRef(false);
  var uploadErrorTrackedRef = useRef(false);
  var _methods$watch = methods.watch(['digitalEditFiles', 'manuscriptComplete']),
    _methods$watch2 = _slicedToArray(_methods$watch, 2),
    digitalEditFiles = _methods$watch2[0],
    manuscriptComplete = _methods$watch2[1];
  var _useAbstractSettings = useAbstractSettings(methods),
    wordCountRange = _useAbstractSettings.wordCountRange,
    abstractType = _useAbstractSettings.abstractType,
    additionalOutputs = _useAbstractSettings.additionalOutputs,
    setWordCountRange = _useAbstractSettings.setWordCountRange,
    setAbstractType = _useAbstractSettings.setAbstractType,
    toggleAdditionalOutput = _useAbstractSettings.toggleAdditionalOutput;
  var hasFile = digitalEditFiles && digitalEditFiles.length > 0;

  // The server-assigned identity of the currently uploaded file (available after upload succeeds).
  var uploadedFileIdentity = (_digitalEditFiles$fin = digitalEditFiles === null || digitalEditFiles === void 0 || (_digitalEditFiles$fin2 = digitalEditFiles.find(function (file) {
    return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
  })) === null || _digitalEditFiles$fin2 === void 0 ? void 0 : _digitalEditFiles$fin2.identity) !== null && _digitalEditFiles$fin !== void 0 ? _digitalEditFiles$fin : null;
  var isUploading = (_digitalEditFiles$som = digitalEditFiles === null || digitalEditFiles === void 0 ? void 0 : digitalEditFiles.some(function (file) {
    return file.status !== FILE_STATUS.STATUS_UPLOAD_SUCCESS && file.status !== FILE_STATUS.STATUS_UPLOAD_ERROR;
  })) !== null && _digitalEditFiles$som !== void 0 ? _digitalEditFiles$som : false;
  var hasSuccessfulUpload = (_digitalEditFiles$som2 = digitalEditFiles === null || digitalEditFiles === void 0 ? void 0 : digitalEditFiles.some(function (file) {
    return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
  })) !== null && _digitalEditFiles$som2 !== void 0 ? _digitalEditFiles$som2 : false;
  var hasUploadError = (_digitalEditFiles$som3 = digitalEditFiles === null || digitalEditFiles === void 0 ? void 0 : digitalEditFiles.some(function (file) {
    return [FILE_STATUS.STATUS_FILETYPE_FAILURE, FILE_STATUS.STATUS_UPLOAD_FAILURE].includes(file.status);
  })) !== null && _digitalEditFiles$som3 !== void 0 ? _digitalEditFiles$som3 : false;
  var _useFormHelpers = useFormHelpers(methods),
    preprocessData = _useFormHelpers.preprocessData;
  var dispatch = useDispatch();
  var manuscriptCompleteField = methods.register('manuscriptComplete');
  var wordCountAttempts = 0;
  var handleFileRemoved = function handleFileRemoved(file) {
    var _file$identity;
    trackAbstractFileRemoved(_objectSpread({
      fileIdentity: (_file$identity = file.identity) !== null && _file$identity !== void 0 ? _file$identity : null
    }, trackingProps));
    uploadErrorTrackedRef.current = false;
    if (file.identity) {
      dispatch(deleteAbstractFile(file.identity));
    }
  };
  var continueButtonContent;
  if (hasUploadError) {
    continueButtonContent = /*#__PURE__*/React.createElement(T, {
      source: "continue"
    });
  } else if (isUploading) {
    continueButtonContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(T, {
      source: "continue"
    }), /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      className: "ms-2",
      icon: "fa-solid fa-spinner-scale",
      spin: true
    }));
  } else {
    continueButtonContent = /*#__PURE__*/React.createElement(T, {
      source: "continue"
    });
  }
  var screens = [{
    title: /*#__PURE__*/React.createElement(T, {
      source: "upload-manuscript"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(digitalEditFiles.length === 0 ? 'submit-digital-edit-form p-3 py-5 mt-2' : '', " ").concat(dragActive ? 'hovered' : '')
    }, /*#__PURE__*/React.createElement(Files, {
      apiRoot: endpoints.researcher,
      maxUploads: 1,
      methods: methods,
      name: "digitalEditFiles",
      type: fileType,
      disabled: submitting,
      fileRenderer: FileRubriq,
      onFileRemoved: handleFileRemoved,
      required: true,
      fileUploadButton: function fileUploadButton(_ref2) {
        var _onClick = _ref2.onClick,
          isDragActive = _ref2.isDragActive,
          disabled = _ref2.disabled;
        return /*#__PURE__*/React.createElement(RubriqUploadButton, {
          onClick: function onClick() {
            _onClick();
          },
          isDragActive: isDragActive,
          disabled: disabled,
          onDragStatusChanged: function onDragStatusChanged(active) {
            return setDragActive(active);
          },
          hasFile: hasFile
        });
      }
    }), digitalEditFiles.length === 0 && /*#__PURE__*/React.createElement("label", {
      className: "control-label text-secondary text-transform-none text-center w-100 me-3 ms-e"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq-abstract-file-upload-requirements",
      params: {
        wordLimit: ''
      }
    })), hasSuccessfulUpload && /*#__PURE__*/React.createElement("div", {
      className: "manuscript-completeness mt-3"
    }, /*#__PURE__*/React.createElement("div", {
      className: "manuscript-completeness__title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "manuscript-completeness"
    })), /*#__PURE__*/React.createElement("div", {
      className: "manuscript-completeness__description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "abstract-manuscript-description"
    })), /*#__PURE__*/React.createElement("div", {
      className: "form-check d-flex align-items-center"
    }, /*#__PURE__*/React.createElement("input", {
      id: "manuscriptComplete",
      type: "checkbox",
      className: "form-check-input",
      name: manuscriptCompleteField.name,
      onChange: manuscriptCompleteField.onChange,
      onBlur: manuscriptCompleteField.onBlur,
      ref: manuscriptCompleteField.ref
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "manuscriptComplete",
      className: "form-check-label ms-2"
    }, /*#__PURE__*/React.createElement(T, {
      source: "confirm-abstract-manuscript"
    }))))), showError && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "file-upload-error"
    }))),
    isValid: function isValid() {
      return hasSuccessfulUpload && manuscriptComplete;
    }
  }, {
    title: /*#__PURE__*/React.createElement(T, {
      source: "abstract-settings"
    }),
    // Displayed at 720px (see `modalWidth` below).
    // NOTE: the drag-and-drop zone called out in the design spec still
    // needs to be scoped with Varnika before it's built — intentionally
    // left out of this pass.
    modalWidth: 550,
    content: /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings"
    }, /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__section-header"
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__icon"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-file-pen"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "abstract-settings__section-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "abstract-word-count-range"
    })), /*#__PURE__*/React.createElement("p", {
      className: "abstract-settings__section-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "abstract-word-count-range-description"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__slider-wrapper"
    }, /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__slider-label"
    }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(T, {
      source: "range"
    })), /*#__PURE__*/React.createElement("span", {
      className: "fw-semibold"
    }, wordCountRange[0], " \u2013 ", wordCountRange[1], " ", /*#__PURE__*/React.createElement(T, {
      source: "small-words"
    }))), /*#__PURE__*/React.createElement(DualRangeSlider, {
      min: WORD_COUNT_MIN,
      max: WORD_COUNT_MAX,
      step: WORD_COUNT_STEP,
      value: wordCountRange,
      onChange: setWordCountRange,
      disabled: submitting
    }), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__slider-ticks"
    }, /*#__PURE__*/React.createElement("span", null, WORD_COUNT_MIN, " ", /*#__PURE__*/React.createElement(T, {
      source: "small-words"
    })), /*#__PURE__*/React.createElement("span", null, Math.round((WORD_COUNT_MIN + WORD_COUNT_MAX) / 2), " ", /*#__PURE__*/React.createElement(T, {
      source: "small-words"
    })), /*#__PURE__*/React.createElement("span", null, WORD_COUNT_MAX, " ", /*#__PURE__*/React.createElement(T, {
      source: "small-words"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__section-header"
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__icon abstract-settings__icon--text"
    }, "Aa"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "abstract-settings__section-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "abstract-type"
    })), /*#__PURE__*/React.createElement("p", {
      className: "abstract-settings__section-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "abstract-type-description"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__cards"
    }, /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: submitting,
      className: "abstract-settings__card ".concat(abstractType === ABSTRACT_TYPE_UNSTRUCTURED ? 'abstract-settings__card--selected' : ''),
      onClick: function onClick() {
        return setAbstractType(ABSTRACT_TYPE_UNSTRUCTURED);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__card-icon-wrapper ".concat(abstractType === ABSTRACT_TYPE_UNSTRUCTURED ? 'abstract-settings__card-icon-wrapper--selected' : '')
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-file-pen"
    })), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__card-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "unstructured"
    })), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__card-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "unstructured-description"
    }))), /*#__PURE__*/React.createElement("button", {
      type: "button",
      disabled: submitting,
      className: "abstract-settings__card ".concat(abstractType === ABSTRACT_TYPE_STRUCTURED ? 'abstract-settings__card--selected' : ''),
      onClick: function onClick() {
        return setAbstractType(ABSTRACT_TYPE_STRUCTURED);
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__card-icon-wrapper ".concat(abstractType === ABSTRACT_TYPE_STRUCTURED ? 'abstract-settings__card-icon-wrapper--selected' : '')
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-file-lines"
    })), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__card-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "structured"
    })), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__card-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "structured-description"
    }))))), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__section-header"
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__icon"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-pen-to-square"
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("p", {
      className: "abstract-settings__section-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "additional-outputs"
    })), /*#__PURE__*/React.createElement("p", {
      className: "abstract-settings__section-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "additional-outputs-description"
    })))), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__addon-cards"
    }, /*#__PURE__*/React.createElement("label", {
      className: "abstract-settings__addon-card ".concat(additionalOutputs.simpleLanguageSummary ? 'abstract-settings__addon-card--selected' : '')
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "abstract-settings__addon-checkbox",
      disabled: submitting,
      checked: additionalOutputs.simpleLanguageSummary,
      onChange: function onChange() {
        return toggleAdditionalOutput('simpleLanguageSummary');
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__addon-icon-wrapper abstract-settings__addon-icon-wrapper--blue"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-check"
    })), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__addon-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__addon-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "simple-language-summary"
    })), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__addon-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "simple-language-summary-description"
    })))), SHOW_GRAPHICAL_ABSTRACT_OPTION && /*#__PURE__*/React.createElement("label", {
      className: "abstract-settings__addon-card ".concat(additionalOutputs.graphicalAbstract ? 'abstract-settings__addon-card--selected' : '')
    }, /*#__PURE__*/React.createElement("input", {
      type: "checkbox",
      className: "abstract-settings__addon-checkbox",
      disabled: submitting,
      checked: additionalOutputs.graphicalAbstract,
      onChange: function onChange() {
        return toggleAdditionalOutput('graphicalAbstract');
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__addon-icon-wrapper abstract-settings__addon-icon-wrapper--purple"
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-shapes"
    })), /*#__PURE__*/React.createElement("div", {
      className: "abstract-settings__addon-text"
    }, /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__addon-title"
    }, /*#__PURE__*/React.createElement(T, {
      source: "graphical-abstract"
    })), /*#__PURE__*/React.createElement("span", {
      className: "abstract-settings__addon-description"
    }, /*#__PURE__*/React.createElement(T, {
      source: "graphical-abstract-description"
    }))))))),
    // Word count / type / add-ons all ship with sensible defaults, so
    // Start is enabled even if the user never touches this screen.
    isValid: function isValid() {
      return true;
    }
  }];
  var currentScreen = screens[currentPageIndex];
  var close = function close(result) {
    var errorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    // Only fire Submission Cancelled for explicit user-initiated dismissals
    // (not after a successful submit, and not after an API error closes the modal).
    if (!result && !errorId) {
      var step = currentPageIndex === 0 && hasSuccessfulUpload ? 'disclaimer' : SCREEN_STEP_NAMES[currentPageIndex];
      trackAbstractSubmissionCancelled(_objectSpread({
        step: step,
        fileIdentity: uploadedFileIdentity
      }, trackingProps));
      var uploadedFile = digitalEditFiles === null || digitalEditFiles === void 0 ? void 0 : digitalEditFiles.find(function (file) {
        return file.identity;
      });
      if (uploadedFile) {
        dispatch(deleteAbstractFile(uploadedFile.identity));
      }
    }
    setSubmitting(false);
    methods.reset(defaultValues);
    setCurrentPageIndex(0);
    setShowError(false);
    wordCountAttempts = 0;
    onClose(result, errorId);
    uploadTrackedRef.current = false;
    uploadErrorTrackedRef.current = false;
  };
  var handleClickNext = function handleClickNext() {
    if (screens[currentPageIndex].isValid()) {
      setShowError(false);
      // Screen 0 (upload) → screen 1 (settings): user has acknowledged the disclaimer
      if (currentPageIndex === 0) {
        trackAbstractDisclaimerAcknowledged(_objectSpread({
          fileIdentity: uploadedFileIdentity
        }, trackingProps));
      }
      if (currentPageIndex < screens.length - 1) {
        setCurrentPageIndex(currentPageIndex + 1);
      }
    } else {
      setShowError(true);
    }
  };
  var _submitAbstract = function submitAbstract(data) {
    trackAbstractGenerationStarted(_objectSpread({
      abstractType: data.abstractType,
      wordCountMin: data.wordLimitMin,
      wordCountMax: data.wordLimitMax,
      simpleLanguageSummary: data.includeSimpleSummary === 'true',
      graphicalAbstract: data.includeGraphicalAbstract === 'true',
      fileIdentity: uploadedFileIdentity
    }, trackingProps));
    setSubmitting(true);
    dispatch(createAbstract(data, false, false)).then(function (res) {
      var digitalEditError = res.error;
      if (digitalEditError) {
        var errorId = digitalEditError.error;
        if (errorId === 'word-count-not-received') {
          if (wordCountAttempts < 12) {
            setTimeout(function () {
              return _submitAbstract(data);
            }, 5000);
            wordCountAttempts += 1;
            return;
          }
        }
        close(false, errorId);
      } else {
        trackAbstractGenerationCompleted(_objectSpread({
          abstractType: data.abstractType,
          wordCountMin: data.wordLimitMin,
          wordCountMax: data.wordLimitMax,
          simpleLanguageSummary: data.includeSimpleSummary === 'true',
          graphicalAbstract: data.includeGraphicalAbstract === 'true',
          fileIdentity: uploadedFileIdentity
        }, trackingProps));
        dispatch(syncUser()).then(function () {
          close(true);
        });
      }
    });
  };
  var handleSubmit = function handleSubmit() {
    methods.handleSubmit(preprocessData(convertFormDataToAbstractCreateRequest, _submitAbstract))();
  };

  // Track Upload Modal Opened when the modal first becomes visible
  useEffect(function () {
    if (open) {
      trackAbstractUploadModalOpened(_objectSpread({
        entryPoint: entryPoint
      }, trackingProps));
    }
  }, [open]);

  // Track File Selected (once per file, on successful upload) and Upload Error
  useEffect(function () {
    if (!digitalEditFiles || digitalEditFiles.length === 0) {
      uploadTrackedRef.current = false;
      uploadErrorTrackedRef.current = false;
      return;
    }
    var latestFile = digitalEditFiles[digitalEditFiles.length - 1];
    if (latestFile.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS && !uploadTrackedRef.current) {
      var _latestFile$name$spli, _latestFile$name, _latestFile$size, _latestFile$identity;
      var extension = (_latestFile$name$spli = (_latestFile$name = latestFile.name) === null || _latestFile$name === void 0 || (_latestFile$name = _latestFile$name.split('.').pop()) === null || _latestFile$name === void 0 ? void 0 : _latestFile$name.toLowerCase()) !== null && _latestFile$name$spli !== void 0 ? _latestFile$name$spli : 'unknown';
      var knownTypes = ['doc', 'docx', 'pdf'];
      trackAbstractFileSelected(_objectSpread({
        fileType: knownTypes.includes(extension) ? extension : 'other',
        fileSize: (_latestFile$size = latestFile.size) !== null && _latestFile$size !== void 0 ? _latestFile$size : null,
        fileIdentity: (_latestFile$identity = latestFile.identity) !== null && _latestFile$identity !== void 0 ? _latestFile$identity : null
      }, trackingProps));
      uploadTrackedRef.current = true;
      uploadErrorTrackedRef.current = false;
    }
    if ([FILE_STATUS.STATUS_FILETYPE_FAILURE, FILE_STATUS.STATUS_UPLOAD_FAILURE].includes(latestFile.status) && !uploadErrorTrackedRef.current) {
      var _latestFile$name$spli2, _latestFile$name2;
      var _extension = (_latestFile$name$spli2 = (_latestFile$name2 = latestFile.name) === null || _latestFile$name2 === void 0 || (_latestFile$name2 = _latestFile$name2.split('.').pop()) === null || _latestFile$name2 === void 0 ? void 0 : _latestFile$name2.toLowerCase()) !== null && _latestFile$name$spli2 !== void 0 ? _latestFile$name$spli2 : 'unknown';
      var _knownTypes = ['doc', 'docx', 'pdf'];
      var errorType = latestFile.status === FILE_STATUS.STATUS_FILETYPE_FAILURE ? 'unsupported_format' : 'corrupted_file';
      trackAbstractUploadError(_objectSpread({
        errorType: errorType,
        fileType: _knownTypes.includes(_extension) ? _extension : 'other'
      }, trackingProps));
      uploadErrorTrackedRef.current = true;
    }
  }, [digitalEditFiles]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    overlayClassName: "react-modal-overlay",
    className: "react-modal modal-padding ".concat(currentScreen.modalWidth ? 'abstract-settings-modal' : ''),
    style: currentScreen.modalWidth ? {
      content: {
        maxWidth: currentScreen.modalWidth,
        width: '100%',
        maxHeight: '90vh'
      }
    } : undefined
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return close(false);
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title"
  }, currentScreen.title)), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: handleSubmit,
    className: "abstract-settings-form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content",
    style: currentScreen.modalWidth ? {
      overflowY: 'auto'
    } : {
      height: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "digital-edits adjust-body-content"
  }, currentScreen.content)), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": t('cancel'),
    type: "button",
    onClick: function onClick() {
      return close(false);
    },
    className: "btn btn-secondary btn-squared me-3"
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  })), currentPageIndex === screens.length - 1 ? /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: submitting,
    className: "btn btn-primary btn-squared me-3",
    key: "start"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start"
  }), submitting ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('continue'),
    type: "button",
    onClick: handleClickNext,
    disabled: !hasSuccessfulUpload || isUploading || !manuscriptComplete,
    className: "btn btn-primary btn-squared me-3",
    key: "continue"
  }, continueButtonContent)))));
};
export default SubmitAbstractModal;